'use strict';

var App = require('app');
var AppState = require('app_state');
var Misc = require('utils/misc');
var Utils = require('models/utils');

var CompanyBillingInfo = Backbone.Model.extend({
    urlRoot: '/api/v1/company/billing',
});

var CompanyFeatures = Backbone.Model.extend({
    urlRoot: '/api/v1/company/features',
});

var CompanyUser = Backbone.Model.extend({
    urlRoot: '/api/v1/company/users',
    defaults: {
        modelType: 'company_user',
    },

    initialize: function (model) {
        // current model represents requesting user? -> set selectable to false
        Utils.SelectableModel.applyTo(this, model.id && model.id !== AppState.user.id);
    },
});

var MailboxModel = Backbone.Model.extend({
    urlRoot: '/api/v1/company/mailboxes',
});

var MailboxCollection = Backbone.Collection.extend({
    model: MailboxModel,
    url: function () {
        return '/api/v1/company/mailboxes';
    },
});

var CompanyUserCollection = Backbone.Collection.extend({
    model: CompanyUser,
    comparator: 'name',

    initialize: function (models, options) {
        this.type = options ? options.type || 'admin' : 'admin';
        Utils.SelectableCollection.applyTo(this, options);
    },

    url: function () {
        return '/api/v1/company/users?' + this.type;
    },
});

var CompanyAPIToken = Backbone.Model.extend({
    urlRoot: '/api/v1/company/api-tokens',
    defaults: {
        modelType: 'api_token',
    },

    initialize: function () {
        Utils.SelectableModel.applyTo(this);
    },
});

// model is single item
var Webhook = Backbone.Model.extend({
    urlRoot: '/api/v1/company/webhook',
    defaults: {
        modelType: 'webhook',
    },

    initialize: function () {
        Utils.SelectableModel.applyTo(this);
    },
});

// collection is list of models
var WebhookCollection = Backbone.Collection.extend({
    model: Webhook,
    url: '/api/v1/company/webhook',

    initialize: function (options) {
        Utils.SelectableCollection.applyTo(this, options);
    },
});

var CompanyAPITokenCollection = Backbone.Collection.extend({
    model: CompanyAPIToken,
    comparator: 'name',
    url: '/api/v1/company/api-tokens',

    initialize: function (options) {
        Utils.SelectableCollection.applyTo(this, options);
    },
});

var API = {
    getBillingInfo: function () {
        var billingInfo = new CompanyBillingInfo();
        var defer = $.Deferred();

        billingInfo.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    getCompanyUsers: function (type) {
        var users = new CompanyUserCollection(undefined, { type: type });
        var defer = $.Deferred();

        users.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    getCompanyFeatures: function () {
        if (AppState.features) {
            return AppState.features;
        }

        var features = new CompanyFeatures();
        var defer = $.Deferred();

        features.fetch({
            success: function (data) {
                AppState.features = data.get('features');
                if (AppState.features.extended_value_transfer) {
                    AppState.features.extended_value_transfer = JSON.parse(AppState.features.extended_value_transfer);
                }
                defer.resolve(AppState.features);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    getAPItokens: function () {
        var tokens = new CompanyAPITokenCollection();
        var defer = $.Deferred();

        tokens.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    getMailboxes: function () {
        return Misc.deferredFct(function (defer) {
            var list = new MailboxCollection();
            list.fetch({
                success: function (data) {
                    defer.resolve(data);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },

    getWebhookList: function () {
        return Misc.deferredFct(function (defer) {
            var webhookList = new WebhookCollection();
            webhookList.fetch({
                method: 'GET',
                success: function (data) {
                    defer.resolve(data);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },
};

App.reqres.setHandler('company:billing', function () {
    return API.getBillingInfo();
});

App.reqres.setHandler('company:users', function (type) {
    return API.getCompanyUsers(type);
});

App.reqres.setHandler('company:features', function () {
    return API.getCompanyFeatures();
});
App.reqres.setHandler('company:mailboxes', function () {
    return API.getMailboxes();
});

App.reqres.setHandler('company:api-tokens', function () {
    return API.getAPItokens();
});

App.reqres.setHandler('webhook:list', function () {
    return API.getWebhookList();
});

module.exports = {
    BillingInfo: CompanyBillingInfo,
    User: CompanyUser,
    Features: CompanyFeatures,
    APIToken: CompanyAPIToken,
    Webhook: Webhook,
};
